module.exports = __webpack_public_path__ + "img/wdsfcz_img.06add5a7.png";